/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSubscriptionListItem,
    MelcoModelsSubscriptionListItemFromJSON,
    MelcoModelsSubscriptionListItemFromJSONTyped,
    MelcoModelsSubscriptionListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSubscriptionListItem
 */
export interface MelcoModelsGenericList1MelcoModelsSubscriptionListItem {
    /**
     * 
     * @type {Array<MelcoModelsSubscriptionListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsSubscriptionListItem
     */
    list: Array<MelcoModelsSubscriptionListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSubscriptionListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSubscriptionListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSubscriptionListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSubscriptionListItem {
    return MelcoModelsGenericList1MelcoModelsSubscriptionListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSubscriptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSubscriptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSubscriptionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSubscriptionListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsSubscriptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSubscriptionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


